import Blue from '~/core'

new Blue({
  name: 'Specifications',
  selector: '.specifications',
  setup(container) {
    const formatEvents = [...container.querySelectorAll('.specifications__format')]
    const tables = [...container.querySelectorAll('.specifications__table')]
    const toggleEvents = 'click enter space'

    formatEvents.forEach((item, i) => {
      this.$addEvents(item, toggleEvents, () => {
        formatEvents.forEach((el) => el.classList.remove('is-active'))
        tables.forEach((el) => el.classList.remove('is-active'))

        item.classList.toggle('is-active')
        tables.find((el) => el.dataset.format === item.dataset.format).classList.add('is-active')
      })
    })
  },
})
